module.exports = __webpack_public_path__ + "static/media/roundedshoulder_normal_right.f0328dde.png";